// extracted by mini-css-extract-plugin
module.exports = {"mapStylesNav":"MapStylesMenu_mapStylesNav__lFXAK","buttonIcon":"MapStylesMenu_buttonIcon__1_WLv","tempButtonContainer":"MapStylesMenu_tempButtonContainer__2FngM"};